import React, { useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { AllStatusProject, ProjectItem } from '@app/interfaces/analytics';
import { NotFoundedPage } from '@app/pages';
import { Loading } from '@app/components/ui';

import {
  useGetSingleAnalyticProjectQuery,
  useGetStatusOfAnalyticProjectQuery,
} from '@app/store/api/analytics-projects.api';

import AnalyticsPageHeader from './blocks/analytics-page-header';

export type AnalyticPageOutlet = {
  project?: ProjectItem | null;
  loading?: boolean;
  currentTemplate: 'chat' | 'voice';
  status?:
    | {
        project_status: AllStatusProject;
      }
    | undefined;
};

const SingleAnalyticPage = React.memo(() => {
  const { id } = useParams();
  const [projectStatus, changeProjectStatus] = useState<AllStatusProject>();
  const [pollingSkip, changePollingSkip] = useState(false);
  //api
  const {
    data: analyticProject,
    isError,
    isLoading,
  } = useGetSingleAnalyticProjectQuery({ id: id || '' });

  const { data: status } = useGetStatusOfAnalyticProjectQuery(
    { id: id, project_status: projectStatus },
    { pollingInterval: pollingSkip ? undefined : 2000 },
  );
  //api

  const analyticPageOutlet: AnalyticPageOutlet = {
    project: analyticProject as ProjectItem,
    loading: isLoading,
    currentTemplate: 'voice',
    status: status,
  };

  if (isError) return <NotFoundedPage />;
  if (isLoading) return <Loading />;
  return (
    <div className="pb-[35px]">
      <AnalyticsPageHeader
        changePollingSkip={changePollingSkip}
        projectStatus={projectStatus}
        status={status}
        changeProjectStatus={changeProjectStatus}
        project={analyticProject}
      />
      <Outlet context={analyticPageOutlet} />
    </div>
  );
});
SingleAnalyticPage.displayName = 'SingleAnalyticPage';
export default SingleAnalyticPage;
